import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../../css/pages.css';
import language from '../../utils/LanguageSettings';
import { fetchLegalComplianceInformation } from '../functions/fetchLegalComplianceInformation';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import gfm from 'remark-gfm';
import RenderSnA from '../functions/renderSnA';

const LegalComplianceInformation: React.FC = () => {
  const path = useLocation();
  const [loading, setLoading] = useState<boolean>(true);
  const [content,setContent] = useState<any>();
  const [seo, setSeo] = useState<any>(null);
  const [ga, setGa] = useState<any>(null);

  useEffect(() => {
    const fetchData = async () => {
        let data = await fetchLegalComplianceInformation(language);
        if(data){
          switch(path.pathname.split("/")[1]){
            case "policy":
                setContent(data?.attributes?.PoliciesStatements);
                setSeo(data?.attributes?.PoliciesStatementsSEO || null);
                setGa(data?.attributes?.PoliciesStatementsGA || null);
                break;
            case "non_discrimination_and_non_harassment_statement":
                setContent(data?.attributes?.NStatement);
                setSeo(data?.attributes?.NStatementSEO || null);
                setGa(data?.attributes?.NStatementGA || null);
                break;
            case "fair-use-policy":
                setContent(data?.attributes?.FairUsePolicy);
                setSeo(data?.attributes?.FairUsePolicySEO || null);
                setGa(data?.attributes?.FairUsePolicyGA || null);
                break;
            case "disclaimer":
                setContent(data?.attributes?.DisclaimerCopyrights);
                setSeo(data?.attributes?.DisclaimerCopyrightsSEO || null);
                setGa(data?.attributes?.DisclaimerCopyrightsGA || null);
                break;
          }
        }
        setLoading(false);
    };
    fetchData();
  }, [language]);

  if (loading) {
    return (<>
        <div id="loader">
            <div className="spinner-border"></div>
        </div>
    </>
    );
  }

  return (
    <>
    <RenderSnA seo={seo} ga={ga} />
    <section id="main-content" className="pt-sm-3 pt-0 pb-5 privacy-policy">
        <div className="static-pages container-fluid"  style={{maxWidth:"1340px"}}>
            <h1 className="my-5" style={{fontWeight:"normal"}}>{content?.Title}</h1>
            <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{content?.Content}</ReactMarkdown>
        </div>
    </section>
    </>
  );
};

export default LegalComplianceInformation;